'use client';

import { useLanguageStore } from '@/store/languageStore';

interface LanguageSelectorProps {
  variant?: 'default' | 'floating';
  className?: string;
}

export function LanguageSelector({ variant = 'default', className = '' }: LanguageSelectorProps) {
  const { language, setLanguage } = useLanguageStore();

  const handleLanguageChange = (lang: 'th' | 'en') => {
    setLanguage(lang);
  };

  if (variant === 'floating') {
    return (
      <div className={`fixed top-3 right-2 z-50 ${className}`}>
        <div className="flex items-center space-x-1 bg-white/10 backdrop-blur-sm rounded-full p-1 shadow-sm">
          <button
            onClick={() => handleLanguageChange('th')}
            className={`px-1 py-1 rounded-full text-xs transition-all duration-200 ${
              language === 'th' 
                ? 'bg-gold text-white shadow-md backdrop-blur-sm' 
                : 'text-white/55 hover:text-white hover:bg-white/[0.06]'
            }`}
          >
            ไทย
          </button>
          <button
            onClick={() => handleLanguageChange('en')}
            className={`px-1 py-1 rounded-full text-xs transition-all duration-200 ${
              language === 'en' 
                ? 'bg-gold text-white shadow-md backdrop-blur-sm' 
                : 'text-white/55 hover:text-white hover:bg-white/[0.06]'
            }`}
          >
            EN
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className={`flex items-center space-x-1 bg-white/10 backdrop-blur-sm rounded-full p-1 shadow-sm ${className}`}>
      <button
        onClick={() => handleLanguageChange('th')}
        className={`px-3 py-1.5 rounded-full text-sm transition-all duration-200 ${
          language === 'th' 
            ? 'bg-gold text-white shadow-md backdrop-blur-sm' 
            : 'text-white/55 hover:text-white hover:bg-white/[0.06]'
        }`}
      >
        ไทย
      </button>
      <button
        onClick={() => handleLanguageChange('en')}
        className={`px-3 py-1.5 rounded-full text-sm transition-all duration-200 ${
          language === 'en' 
            ? 'bg-gold text-white shadow-md backdrop-blur-sm' 
            : 'text-white/55 hover:text-white hover:bg-white/[0.06]'
        }`}
      >
        EN
      </button>
    </div>
  );
}